export enum AuroraFinanceProductTypeEnum {
  PROPOSAL = "Proposal",
}
